import { asyncComponent } from "../../helpers/asyncComponent";

export const DatePickerAsync = asyncComponent({
  module: () => import("./DatePicker"),
  component: (module) => module["default"],
});
